import React, { useState } from 'react';
import { Navbar, Nav, Button, Offcanvas, Container } from 'react-bootstrap';
import { 
  FaBuilding, FaBookOpen, FaHome, FaPenAlt, FaLaptopCode, 
 FaUsers, FaHeadset,
 FaSuitcase,
} from 'react-icons/fa';
import logo from '../images/logo.png';
import logo1 from '../images/olewin.png';
import "../styles/components/Navbar.css";

const CustomNavbar = ({ user, onLogout }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleShowOffcanvas = () => setShowOffcanvas(true);
  const handleCloseOffcanvas = () => setShowOffcanvas(false);

  return (
    <>
      <Navbar expand="lg" fixed="top" className="navbar-custom">
        <Container fluid>
          {/* Brand Logo and Studio Button */}
          <div className="d-flex align-items-center">
            <Navbar.Brand href="/" className="d-flex align-items-center mr-3">
              <img src={logo} alt="Logo" className="navlogo img-fluid" />
            </Navbar.Brand>
          </div>

          {/* Hamburger Menu for Mobile */}
          <Button
            variant="dark"
            className="d-lg-none"
            onClick={handleShowOffcanvas}
          >
            Menu
          </Button>

          {/* Desktop Navigation */}
          <Navbar.Collapse id="navbarNav" className="d-none d-lg-flex justify-content-between">
            <Nav className="mx-auto">
              <Nav.Link href="/" className="fw-bold nav-link-custom">
                <FaHome className="me-1" /> Home
              </Nav.Link>

              <Nav.Link href="/careers_page" className="fw-bold nav-link-custom">
                <FaSuitcase className="me-1" /> Careers
              </Nav.Link>
              
              <Nav.Link href="/explore_solutions" className="fw-bold nav-link-custom">
                <FaBuilding className="me-1" /> Solutions
              </Nav.Link>
              
              <Nav.Link href="/case" className="fw-bold nav-link-custom">
                <FaBookOpen className="me-1" /> Case Study
              </Nav.Link>
              
              <Nav.Link href="/internships" className="fw-bold nav-link-custom">
                <FaBookOpen className="me-1" /> Internships
              </Nav.Link>
              
              <Nav.Link href="/contact" className="fw-bold nav-link-custom">
                <FaHeadset className="me-1" /> Contact
              </Nav.Link>
              
              <Nav.Link href="/about" className="fw-bold nav-link-custom">
                <FaUsers className="me-1" /> About
              </Nav.Link>
              
              <div className="bg-transparent d-flex fw-bolder align-items-center justify-content-center gap-2 px-1 py-3">
                <img src={logo1} alt="Studio" style={{ width: '25px', height: '25px', display: 'block' }} />
                <span>
                  <a className='text-dark studio-link' href="/studio">Studio</a>
                </span>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleCloseOffcanvas}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header className="bg-light" closeButton>
          <Offcanvas.Title className="mb-3">Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="bg-light  ">
          <Nav className="flex-column">
            <Nav.Link href="/" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaHome className="me-1" /> Home
            </Nav.Link>
       
            
            <Nav.Link href="/request-form" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaPenAlt className="me-1" /> Request Form
            </Nav.Link>
            
            <Nav.Link href="/careers" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaSuitcase className="me-1" /> Careers
            </Nav.Link>
            
            <Nav.Link href="/case-study" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaBookOpen className="me-1" /> Case Study
            </Nav.Link>
            
            <Nav.Link href="/contact" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaHeadset className="me-1" /> Contact
            </Nav.Link>
            
            <Nav.Link href="/about" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaUsers className="me-1" /> About
            </Nav.Link>
            
            <Nav.Link href="/studio" onClick={handleCloseOffcanvas} className="mobile-nav-link">
              <FaLaptopCode className="me-1" /> OLEWIN Studio
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CustomNavbar;